module.exports = __webpack_public_path__ + "static/media/leftInputGain.1e6a2928.png";